import { render, staticRenderFns } from "./CardVertical.vue?vue&type=template&id=33ced7a6"
import script from "./CardVertical.vue?vue&type=script&lang=js"
export * from "./CardVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductCondition: require('/opt/build/repo/components/product/Condition.vue').default,ProductStatus: require('/opt/build/repo/components/product/Status.vue').default,ProductPrice: require('/opt/build/repo/components/product/Price.vue').default,EshopCartAdd: require('/opt/build/repo/node_modules/@evince/eshop/lib/packages/CartAdd.vue').default})
